interface GuidesSectionErrorProps {
  error: Error;
  resetErrorBoundary?: () => void;
}

export function GuidesSectionError({
  error,
  resetErrorBoundary,
}: GuidesSectionErrorProps) {
  return (
    <section className="py-16 sm:py-20 lg:py-24 font-outfit bg-white w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
          {/* Error Icon */}
          <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mb-6">
            <svg
              className="w-8 h-8 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          {/* Error Message */}
          <h3 className="text-2xl sm:text-3xl font-bold text-[#0B0B0B] mb-3">
            Failed to Load Guides
          </h3>
          <p className="text-base sm:text-lg text-gray-600 mb-8 max-w-md">
            {error.message ||
              "Something went wrong while fetching the guides. Please try again."}
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            {resetErrorBoundary && (
              <button
                onClick={resetErrorBoundary}
                className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-[#0B0B0B] text-white font-medium hover:bg-[#1a1a1a] transition-colors"
              >
                <svg
                  className="w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                Try Again
              </button>
            )}
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center justify-center px-6 py-3 rounded-lg border border-gray-300 bg-white text-gray-700 font-medium hover:bg-gray-50 transition-colors"
            >
              Reload Page
            </button>
          </div>

          {/* Additional Help Text */}
          <p className="text-sm text-gray-500 mt-8">
            If the problem persists, please contact support or try again later.
          </p>
        </div>
      </div>
    </section>
  );
}
